/* istanbul ignore file */
import { Paragraph } from '@econsult/econsult-ui/dist/components/shared/typography';
import { CharacterCounter, Textarea } from '@econsult/econsult-ui/dist/components/Textarea';
import { Div } from 'components/Div/styles';
import styled from 'styled-components';

interface TextAreaWrapperProps {
  isActive: boolean;
  hasBorder?: boolean;
}

interface TextAreaWrapperInnerProps {
  isActive: boolean;
  hasBorder?: boolean;
}

export const Content = styled.div`
  display: grid;
  grid-template-rows: repeat(3, auto);
  transition: filter 0.3s ease;
  width: 100%;
`;

export const TextAreaWrapper = styled.div<TextAreaWrapperProps>`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: start;
  flex-grow: 1;
  min-width: 88px;
  height: 48px;
  border-radius: 4px;
  background: ${({ theme }) => theme.colorBackgroundBrightWhite};
  border: 1px solid ${({ theme }) => theme.colorPrimaryPrimary80};

  & #messageCharCounter {
    margin-top: 0;
    color: ${({ theme }) => theme.colorNeutralNeutral3};
  }
  && .MuiOutlinedInput-input {
    opacity: ${({ isActive }) => (isActive ? 1 : 0)};
    height: 100%;
  }
`;

export const TextAreaWrapperInner = styled.div<TextAreaWrapperInnerProps>`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  overflow: scroll;
  width: 100%;
  border-radius: 4px;

  & .MuiOutlinedInput-root {
    font-size: 16px;
    width: 100%;
    padding: 8px 0;
    margin: 0;
    fieldset {
      border: none;
    }
  }
  & .MuiOutlinedInput-input {
    --input-border-color: ${({ isActive, theme }) => (isActive ? theme.colorNeutralNeutral9 : 'transparent')};
    box-sizing: border-box;
    padding: 1rem 0.5rem 1rem;
    width: 100%;
    color: ${({ theme }) => theme.colorNeutralBlack};
    &:focus {
      min-height: ${({ isActive }) => (isActive ? 'initial' : 'unset !important')};
    }
    &&:placeholder-shown {
      opacity: 1;
    }
    &::placeholder {
      color: ${({ theme }) => theme.colorNeutralBlack};
      opacity: 0;
    }
  }
`;

export const CopilotContainer = styled(Div)`
  display: flex;
  flex-direction: row;
  padding: 16px 0 4px 0;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  gap: 8px;
`;

export const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  margin: 0;
  height: 48px;
  width: 48px;
  min-width: 48px;
  background-color: transparent;
`;

const ParagraphTinyRegular = styled(Paragraph).attrs({ typography: 'ParagraphTinyRegular' })`
  margin: 0;
`;

export const PromptSupportCopyText = styled(ParagraphTinyRegular)`
  color: ${({ theme }) => theme.colorNeutralNeutral3};
  font-size: 12px;
  margin-top: 8px;
  padding: 0;
`;

export const FakePlaceholder = styled(ParagraphTinyRegular)`
  margin-left: 10px;
  margin-top: 2px;
  font-size: 16px;
  && {
    box-sizing: border-box;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    display: inline-block;
    padding-top: 14px;
    color: #6C6C6C;
  }
  &,
  & * {
    pointer-events: none;
  }
`;

export const MaxCharMessageWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const MaxCharMessage = styled(ParagraphTinyRegular)`
  color: ${({ theme }) => theme.colorStatusError};
  margin-right: auto;
`;

export const MaxCharacterContainerRow = styled(Div)`
  padding: 0.5rem 0 0;
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  width: 100%;
  align-items: center;
`;

export { CharacterCounter, Textarea };

export const ExtraSummaryResponseContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  min-width: 400px;
  background-color: ${({ theme }) => theme.colorBackgroundSoftWhite};
`;

export const ExtraSummaryButtonContainer = styled(Div)`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 8px;
  width: 100%;
  margin-top: 16px;
`;

export const ExtraSummaryContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  width: 100%;
  padding: 16px;
  background-color: ${({ theme }) => theme.colorBackgroundBrightWhite};
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colorPrimaryPrimary80};
`;

export const CopilotResponseContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  min-width: 400px;
  background-color: ${({ theme }) => theme.colorBackgroundSoftWhite};
`;

export const ResponseButtonContainer = styled(Div)`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 8px;
  width: 100%;
  margin-top: 16px;
`;

export const CopilotQueryResponseContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  width: 100%;
`;

export const SummaryModalToggleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  margin-top: 8px;
`;
